import { FC } from "react";
import SettingLayout from "../../layout/SettingLayout/SettingLayout";
import ApiKeysSection from "../../components/ApiKeysSection/ApiKeysSection";

const ApiKeysView: FC = () => {
    return (
        <SettingLayout title="API Keys">
            <ApiKeysSection />
        </SettingLayout>
    );
};

export default ApiKeysView;
